import React, { useEffect, useRef, useState } from "react";

const LiveStreamContainer = ({
  activityId,
  token,
  mode = 1,
  webSDKVersion = "2.0.27-beta.3",
  isFullScreenPlayer = false,
}) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !token || !activityId || !webSDKVersion) return;

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    const iframeWin = iframe.contentWindow;

    // 🧩 Write full HTML into iframe
    iframeDoc.open();
    iframeDoc.write(`
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="stylesheet" href="https://res.bytepluscdn.com/obj/bp-console-fe-sg/livesaas-client/mobile/css/index.${webSDKVersion}.css">
          <style>
            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
              height: 100%;
              background: #111;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .init-loading {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 12px;
              color: white;
              height: 100%;
              width: 100%;
            }
            .spin-loading-animation {
              animation: spin 1s linear infinite;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            #byteplus-live-stream-player {
              width: 100%;
              height: 100%;
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          </style>
        </head>
        <body>
          <div id="loading" class="init-loading">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="spin-loading-animation"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-dasharray="31.416"
                stroke-dashoffset="31.416"
              />
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-dasharray="31.416"
                stroke-dashoffset="23.562"
                opacity="0.3"
              />
            </svg>
            <p>Loading...</p>
          </div>
          <div id="byteplus-live-stream-player"></div>
          <script src="https://res.bytepluscdn.com/obj/bp-console-fe-sg/livesaas-client/mobile/js/index.${webSDKVersion}.js"></script>
        </body>
      </html>
    `);
    iframeDoc.close();

    // 🧠 Wait until SDK script is available inside iframe
    const checkSDK = setInterval(() => {
      if (iframeWin.ByteLiveWebSDK) {
        clearInterval(checkSDK);

        const sdk = new iframeWin.ByteLiveWebSDK({
          activityId,
          token,
          service: "liveDemo",
          mode,
          modules: [
            { id: "byteplus-live-stream-player", mode: "mobile-portrait" },
          ],
          options: {
            saveUserInfo: true,
            softSolution: true,
            playerConf: { loop: true },
          },
        });

        // ✅ SDK Ready
        sdk.on("ready", () => {
          console.log("✅ BytePlus SDK ready inside iframe");

          const loader = iframeDoc.getElementById("loading");
          if (loader) loader.style.display = "none";

          const player = iframeDoc.getElementById(
            "byteplus-live-stream-player"
          );
          if (player) {
            Object.assign(player.style, {
              display: "block",
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              width: "100%",
              height: "100%",
            });

            // 🩹 Force layout reflow
            setTimeout(() => {
              iframeWin.dispatchEvent(new iframeWin.Event("resize"));
            }, 500);
          }
        });

        // ❌ Handle Errors
        sdk.on("error", (err) => {
          console.error("BytePlus SDK Error:", err);
          const loader = iframeDoc.getElementById("loading");
          if (loader)
            loader.innerHTML = `<p style="color:red; text-align: center; max-width: 80%; font-size: ${isFullScreenPlayer ? "16px" : "7px"};">Failed to load: ${err?.message} Please try again later or <a href='https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?' target='_blank'>Contact Support</a></p>`;
        });
      }
    }, 300);

    return () => clearInterval(checkSDK);
  }, [activityId, token, mode, webSDKVersion, isFullScreenPlayer]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0,0,0,0.2)",
      }}
    >
      <iframe
        ref={iframeRef}
        title="BytePlus Live Stream"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "inherit",
          display: "block",
        }}
      />
    </div>
  );
};

export default LiveStreamContainer;
